import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import Confirm from 'react-confirm-bootstrap';

export function ConfirmDeleteSavedAccount({ onConfirm, onClose, bankAccount, children }) {
  return (
    <Confirm
      onConfirm={onConfirm}
      onClose={onClose}
      body={`Are you sure you would like to remove the ${bankAccount} account?`}
      confirmText={`Remove ${bankAccount}`}
      title="Confirm Account Removal"
    >
      {children}
    </Confirm>
  );
}

export class ConfirmUploadBankCsv extends React.Component {
  render() {
    return (
      <Confirm
        onConfirm={() => window.history.back()}
        body="Your CSV file has been uploaded successfully"
        confirmText="Return to home"
        cancelText="Dismiss"
        title="File uploaded"
        confirmBSStyle="primary"
        visible={true}
      >
        <div> </div>
      </Confirm>
    );
  }
}

ConfirmDeleteSavedAccount.propTypes = {
  onConfirm: PropTypes.func.isRequired,
  children: PropTypes.object.isRequired,
  onClose: PropTypes.func,
  bankAccount: PropTypes.string,
};

ConfirmDeleteSavedAccount.defaultProps = {
  onClose: _.noop,
  bankAccount: null,
};
